import ManopNavigator from "./components/ManopNavigator";
customElements.define('manop-navigator', ManopNavigator, {extends: 'ul'});